import { GroupChannel } from "@sendbird/chat/groupChannel";

export const DEFAULT_URL_PREFIX = "https://static.sendbird.com/sample/cover/cover_";

export const getChannelAvatarSource = (channel: GroupChannel, currentUserId: string): string => {
  if (channel?.coverUrl) {
    if (!new RegExp(`^${DEFAULT_URL_PREFIX}`).test(channel.coverUrl)) {
      return channel.coverUrl;
    }
  }

  return (
    (channel?.members || [])
      .filter((member) => member.userId !== currentUserId)
      .map(({ profileUrl }) => profileUrl)
      .pop() || (channel?.coverUrl ? channel.coverUrl : "")
  );
};
